import React from 'react'

const DisplayPriceUiDefault = (props) => {
    return (
        <React.Fragment>
            {/************************* PINTAMOS PRECIOS **********************************/}
            {props.hasDiscount ? (
                <React.Fragment>
                    {props.showOldPrice && (
                        <React.Fragment>
                            <del>
                                {props.price}&nbsp;
                                {props.priceFormat}
                            </del>
                            <br />
                        </React.Fragment>
                    )}
                    <span className='text price'>
                        {props.discountPrice}&nbsp; {/*PRECIO DESCUENTO*/}
                        {props.discountFormat} {/*FORMATO DESCUENTO*/}
                    </span>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <span className='text price'>
                        {props.price}&nbsp;
                        {props.priceFormat}
                    </span>
                </React.Fragment>
            )}
            {/********************************************************************************/}
        </React.Fragment>
    )
}

export default DisplayPriceUiDefault